import React, { useEffect, useState } from 'react'
import { CheckBox, FormCustom, Input } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'
import { doToast } from '../../../utils'
import { toast } from 'react-toastify'
import { Button } from 'react-bootstrap'

const ProfileTag = ({ rowId, setReload, profileId }) => {
  const [row, setRow] = useState({
    p_id_profile: '',
    p_permissions: [],
    p_profile: [],
    p_main_profile: ''
  })
  const [ready, setReady] = useState(false);

  const dataSubmit = useMemo(() => {
    const finalPermissions = []
    row.p_permissions.forEach(tpm => {
      tpm.childrens.forEach(tp => {
        tp.childrens.forEach(t => {
          if (parseInt(t?.was_changed) === 1) {
            finalPermissions.push(t)
          }
        })
      })
    })

    return {
      ...row,
      p_permissions: JSON.stringify(finalPermissions)
    };
  }, [row])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/tag/profile',
    hasFile: true,
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/tag/profile/' + rowId,
    rowId: rowId
  })

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          if (rowId) {
            setRow({
              p_id_profile: getRow.id_profile,
              p_permissions: getRow.permissions,
              p_profile: getRow.profile,
              p_main_profile: getRow.main_profile
            })
          }
          setReady(true)
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready])

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom onSubmit={() => {
      if (!row.p_main_profile) {
        doToast({
          response: 'warning',
          message: 'Debe selecionar una página principal',
          toast
        })

        return
      }
      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      <Input
        text="Perfil"
        placeholder="Perfil"
        classNameParent="col-12 mb-3"
        value={row.p_profile.name_profile}
        readOnly
      />
      <div className="col-12">
        <div className="table-responsive">
          <table className='table table-sm'>
            <thead>
              <tr>
                <th className='bg-dark text-white'>Permiso</th>
                <th className='bg-dark text-white'>Estado</th>
              </tr>
            </thead>
            <tbody>
              {React.Children.toArray(row.p_permissions.map((tpm, tpmIdx) => {
                const secondLevel = tpm.childrens;

                return <>
                  <tr>
                    <td>
                      <div className="d-flex">
                        <i className="fas fa-angle-right me-2 align-self-center"></i>
                        <div>
                          {tpm.parent.name_tag}
                        </div>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  {React.Children.toArray(secondLevel.map((tp, tpIdx) => {
                    const thirdLevel = tp.childrens;

                    return <>
                      <tr>
                        <td>
                          <div>
                            <strong>{tp.parent.name_tag}</strong>
                          </div>
                        </td>
                        <td></td>
                      </tr>

                      {React.Children.toArray(thirdLevel.map((t, tIdx) => {
                        return <>
                          <tr>
                            <td>
                              <div className='d-flex'>
                                <div className="ms-4 me-2 align-self-center">
                                  {t.name_tag}
                                </div>
                                {parseInt(t.enabled_tag_profile) === 1 && <div className={`align-self-center badge bg-${t.href_tag === row.p_main_profile ? 'success' : 'link'} cur-pointer`} style={{
                                  opacity: t.href_tag === row.p_main_profile ? 1 : .3
                                }} onClick={_ => {
                                  setRow({
                                    ...row,
                                    p_main_profile: t.href_tag
                                  })
                                }}>
                                  Página Principal
                                </div>}
                              </div>
                              {t.actions.length > 0 && <div className='ms-4 mt-2 mb-2'>
                                {React.Children.toArray(t.actions.map((a, aIdx) => {
                                  return <div className='d-flex'>
                                    <div>
                                      <CheckBox
                                        classNameParent="me-2"
                                        id={`p_permissions[${tpmIdx}].childrens[${tpIdx}].childrens[${tIdx}].actions[${aIdx}].enabled_tag_profile_action`}
                                        checked={parseInt(a.enabled_tag_profile_action) === 1}
                                        onChange={e => {
                                          const { checked } = e.target;
                                          const newPermissions = [...row.p_permissions];

                                          newPermissions[tpmIdx].childrens[tpIdx].childrens[tIdx].actions[aIdx].enabled_tag_profile_action = checked ? 1 : 0;
                                          newPermissions[tpmIdx].childrens[tpIdx].childrens[tIdx].was_changed = 1;

                                          setRow({
                                            ...row,
                                            p_permissions: newPermissions
                                          })
                                        }}
                                      />
                                    </div>
                                    <div className='text-muted align-self-center d-flex'>
                                      <Button size="xs" variant={a.color_action} className="d-flex">
                                        <i className={a.icon_action + ' me-2 text-white'}></i>
                                        <div className='align-self-center text-white'>{a.name_action}</div>
                                      </Button>
                                    </div>
                                  </div>
                                }))}
                              </div>}
                            </td>
                            <td align='center'>
                              <CheckBox
                                id={`tpm${tpmIdx}_tp${tpIdx}_t${tIdx}`}
                                checked={parseInt(t.enabled_tag_profile) === 1}
                                onChange={e => {
                                  const newPermissions = [...row.p_permissions];
                                  newPermissions[tpmIdx].childrens[tpIdx].childrens[tIdx].enabled_tag_profile = e.target.checked ? 1 : 0;
                                  newPermissions[tpmIdx].childrens[tpIdx].childrens[tIdx].was_changed = 1;

                                  if (!row.p_main_profile && e.target.checked) {
                                    setRow({
                                      ...row,
                                      p_main_profile: newPermissions[tpmIdx].childrens[tpIdx].childrens[tIdx].href_tag,
                                      p_permissions: newPermissions
                                    })
                                  } else if (newPermissions[tpmIdx].childrens[tpIdx].childrens[tIdx].href_tag === row.p_main_profile) {
                                    setRow({
                                      ...row,
                                      p_main_profile: '',
                                      p_permissions: newPermissions
                                    })
                                  } else {
                                    setRow({
                                      ...row,
                                      p_permissions: newPermissions
                                    })
                                  }
                                }}
                              />
                            </td>
                          </tr>
                        </>
                      }))}
                    </>
                  }))}
                </>
              }))}
            </tbody>
          </table>
        </div>
      </div>
    </FormCustom>
  </ReactPlaceholder>
}

ProfileTag.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  ProfileTag
};